import { useTranslation } from 'react-i18next';

import { Button, Select, Spin, Typography } from '@arco-design/web-react';

import { EmptyTips } from '@/components/EmptyTips';
import { TagsSearch } from '@/components/Search/tags-search';

import { ARTIFACT_TYPE_OPTIONS } from '../constants';
import styles from '../index.module.less';
import type { ListContentProps } from '../types';
import { ImageCard } from './ImageCard';
import { ImageListPagination } from './ImageListPagination';

/** 列表区（搜索 + 列表，分页可选）；容器镜像时在搜索前展示制品类型 */
export function ImagesListContent({
  listState,
  selectedKey,
  onSelect,
  hideLabel,
  showPagination,
  hideArtifactTypeSelector,
  readOnly = false,
  style,
}: ListContentProps) {
  const { t } = useTranslation();
  const { data, loading, onSearch, handleReset, refreshList, artifactType, setArtifactType } = listState;
  const showArtifactToolbar = setArtifactType !== undefined && !hideArtifactTypeSelector;

  const tagsSearch = (
    <TagsSearch
      filters={[{ key: 'name', type: 'input', label: t('common:image') }]}
      tagBarStyle={{ marginBottom: 8 }}
      getData={onSearch}
      refresh={refreshList}
      queryName="imageSearch"
      hideDataCenterSwitcher
      extra={
        <Button type="primary" onClick={handleReset}>
          {t('common:reset')}
        </Button>
      }
    />
  );

  return (
    <Spin loading={loading} block>
      {!hideLabel ? (
        <Typography.Text bold style={{ display: 'block', marginBottom: 12 }}>
          {t('common:image')}
        </Typography.Text>
      ) : null}
      {!readOnly ? (
        showArtifactToolbar ? (
          <div style={{ display: 'flex', gap: 10 }}>
            <Select
              style={{ width: 200 }}
              value={artifactType}
              onChange={setArtifactType}
              options={ARTIFACT_TYPE_OPTIONS}
              placeholder="全部"
              allowClear
            />
            {tagsSearch}
          </div>
        ) : (
          tagsSearch
        )
      ) : null}
      <div className={styles.imageList} style={style}>
        {data.length > 0 ? (
          data.map((item) => {
            const isSelected = selectedKey === item.key;
            return (
              <ImageCard
                key={item.key}
                item={item}
                isSelected={isSelected}
                disabled={!readOnly && !!item.disabled}
                readOnly={readOnly}
                onChange={onSelect}
              />
            );
          })
        ) : (
          <EmptyTips />
        )}
      </div>
      {showPagination ? <ImageListPagination listState={listState} variant="inline" /> : null}
    </Spin>
  );
}
